import type { KeyboardEvent } from "react";

/** Arrow Up/Down moves focus between the `selector` matches inside the handler's element. */
export function arrowFocus(e: KeyboardEvent<HTMLElement>, selector: string): void {
  if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
  const items = Array.from(e.currentTarget.querySelectorAll<HTMLElement>(selector));
  const i = items.indexOf(document.activeElement as HTMLElement);
  if (i < 0) return;
  e.preventDefault();
  const step = e.key === "ArrowDown" ? 1 : -1;
  items[(i + step + items.length) % items.length].focus();
}
